import { createProviderRegistry } from '../createProviderRegistry'
import { agoraSignalingAdapter } from './agora'

export function createSignalingProviderRegistry({ providers = [] } = {}) {
  const registry = createProviderRegistry('signaling')

  ;[agoraSignalingAdapter, ...providers].forEach((provider) => {
    if (provider) {
      registry.register(provider)
    }
  })

  return registry
}
